import Vue from 'vue'
import Router from 'vue-router'
//进度条样式
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

Vue.use(Router)
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {

	return originalPush.call(this, location).catch(err => err)

}




Vue.use(Router)

const commonRoutes = [
	//主页面
	{
		path: '/',
		name: 'index',
		component: resolve => require(['../pages/index'], resolve),
		children:[
			{
				path: '/home',
				name: 'home',
				component: resolve => require(['../pages/home'], resolve),
			},
			{
				path: '/about',
				name: 'about',
				component: resolve => require(['../pages/about'], resolve),
			},
			{
				path: '/product',
				name: 'product',
				component: resolve => require(['../pages/product'], resolve),
			},
			{
				path: '/case',
				name: 'case',
				component: resolve => require(['../pages/case'], resolve),
			},
			{
				path: '/cooperation',
				name: 'cooperation',
				component: resolve => require(['../pages/cooperation'], resolve),
			},
		]
	},



]

// 本地所有的页面 需要配合后台返回的数据生成页面
export const asyncRoutes = {
	home: {
		path: 'home',
		name: 'home',
		meta: { title: '主页' },
		component: () => import('../pages/index.vue'),
	},

}

const createRouter = () => new Router({
	routes: commonRoutes,
})

const router = createRouter()

export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher
}

export default router




// WEBPACK FOOTER //
// ./src/router/index.js